"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _DOMSelectors = require("./constants/DOMSelectors");

var _DOMShims = require("./utils/DOMShims");

var NavInjector =
/*#__PURE__*/
function () {
  function NavInjector() {
    (0, _classCallCheck2.default)(this, NavInjector);
    this.siblings = [];
    this.nav = null;
  }

  (0, _createClass2.default)(NavInjector, [{
    key: "insertBefore",
    value: function insertBefore(sibling) {
      this._insert(sibling, 'before');
    }
  }, {
    key: "insertAfter",
    value: function insertAfter(sibling) {
      this._insert(sibling, 'after');
    }
  }, {
    key: "_insert",
    value: function _insert(sibling, position) {
      if (!(0, _DOMShims.isElement)(sibling.element)) return;
      this.siblings.push((0, _extends2.default)({}, sibling, {
        position: position
      }));
      this.render();
    }
  }, {
    key: "_getNav",
    value: function _getNav() {
      if ((0, _DOMShims.isElement)(this.nav)) {
        return this.nav;
      }

      var nav = document.getElementById(_DOMSelectors.HUBSPOT_NAV_V4_ID) || document.getElementById(_DOMSelectors.HUBSPOT_NAV_V3_ID);

      if ((0, _DOMShims.isElement)(nav)) {
        this.nav = nav;
      }

      return nav;
    }
  }, {
    key: "_getSiblingsToRender",
    value: function _getSiblingsToRender() {
      if (this.siblings.length === 1) {
        return this.siblings;
      }

      return this.siblings.reduce(function (accumulator, sibling) {
        if (sibling.isPriority || accumulator.length === 0) {
          accumulator.push(sibling);

          if (accumulator.length > 1) {
            accumulator = accumulator.reduce(function (accumulatorInner, siblingInner) {
              if (siblingInner.isPriority) {
                accumulatorInner.push(siblingInner);
              }

              return accumulatorInner;
            }, []);
          }
        }

        return accumulator;
      }, []);
    }
  }, {
    key: "_getSiblingContainer",
    value: function _getSiblingContainer(hsNav, elements, id) {
      var container = (0, _DOMShims.getOrCreateElement)(id);
      container = (0, _DOMShims.replaceChildren)(container, elements);

      if (hsNav.className.indexOf(_DOMSelectors.HUBSPOT_NAV_NO_BOTTOM_MARGIN_CLASS) !== -1) {
        container.className += " " + _DOMSelectors.HUBSPOT_NAV_NO_BOTTOM_MARGIN_CLASS;
      }

      return container;
    }
  }, {
    key: "remove",
    value: function remove(key) {
      this.siblings = this.siblings.reduce(function (accumulator, sibling) {
        if (sibling.key !== key) {
          accumulator.push(sibling);
        }

        return accumulator;
      }, []);
      this.render();
    }
  }, {
    key: "removeAll",
    value: function removeAll() {
      this.siblings = [];
      this.render();
    }
  }, {
    key: "_renderBefore",
    value: function _renderBefore() {
      var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var hsNav = this._getNav();

      if (!(0, _DOMShims.isElement)(hsNav)) return;

      var container = this._getSiblingContainer(hsNav, elements, _DOMSelectors.HUBSPOT_NAV_BEFORE_ID);

      hsNav.parentNode.insertBefore(container, hsNav);
    }
  }, {
    key: "_renderAfter",
    value: function _renderAfter() {
      var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var hsNav = this._getNav();

      if (!(0, _DOMShims.isElement)(hsNav)) return;

      var container = this._getSiblingContainer(hsNav, elements, _DOMSelectors.HUBSPOT_NAV_AFTER_ID);

      (0, _DOMShims.insertAfter)(container, hsNav);
    }
  }, {
    key: "render",
    value: function render() {
      var siblingsToRender = this._getSiblingsToRender();

      var elementsToRenderBeforeNav = [];
      var elementsToRenderAfterNav = [];
      siblingsToRender.forEach(function (sibling) {
        if (sibling.position === 'before') {
          elementsToRenderBeforeNav.push(sibling.element);
        } else if (sibling.position === 'after') {
          elementsToRenderAfterNav.push(sibling.element);
        }
      });

      this._renderBefore(elementsToRenderBeforeNav);

      this._renderAfter(elementsToRenderAfterNav);
    }
  }]);
  return NavInjector;
}();

var _default = new NavInjector();

exports.default = _default;
module.exports = exports.default;